// Breach Register: the routes and the sidebar rows of `wealth.compliance.breach-register` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.breach-register',
    routes: [
        {
            frontend: 'comply',
            path: 'breach-register',
            lazy: () => import('@/pages/comply/breach-register/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'breach-register',
            label: 'Breach Register',
            href: '/comply/breach-register',
            icon: 'FileWarning',
            group: 'monitoring',
            order: 420,
            wip: true,
        },
    ],
});
